module.exports = __webpack_public_path__ + "img/scroll8.4240585d.png";